import { useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { BrowserView, MobileView } from 'react-device-detect'
import { useTranslation } from 'react-multi-lang'
import { RotatingLines } from 'react-loader-spinner'
import { toast } from 'react-toastify'
import axios from 'axios'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLocationDot, faPaperPlane, faPen, faPhone, faUser } from '@fortawesome/free-solid-svg-icons'
import { Fade } from 'react-awesome-reveal'
import InputText from '../Input/InputText'
import InputTextarea from '../Input/InputTextarea'
import Button from '../Utils/Button'
import '../../styles/Contact/Contact.css'

function Contact({ ip }) {

    const text = useTranslation()
    const [isLoadingMessage, setIsLoadingMessage] = useState(false)
    const firstnameRef = useRef(null)
    const [firstname, setFirstname] = useState("")
    const [firstnameError, setFirstnameError] = useState(null)
    const lastnameRef = useRef(null)
    const [lastname, setLastname] = useState("")
    const [lastnameError, setLastnameError] = useState(null)
    const emailRef = useRef(null)
    const [email, setEmail] = useState("")
    const [emailError, setEmailError] = useState(null)
    const phoneRef = useRef(null)
    const [phone, setPhone] = useState("")
    const [phoneError, setPhoneError] = useState(null)
    const subjectRef = useRef(null)
    const [subject, setSubject] = useState("")
    const [subjectError, setSubjectError] = useState(null)
    const messageRef = useRef(null)
    const [message, setMessage] = useState("")
    const [messageError, setMessageError] = useState(null)

    function sendMessage() {

        setIsLoadingMessage(true)
        var error = []
        if (!firstnameRef.current.nameValidation(firstname)) {
            error.push("Le prénom est incorrect")
        }
        if (!lastnameRef.current.nameValidation(lastname)) {
            error.push("Le nom est incorrect")
        }
        if (!emailRef.current.emailValidationOnBlur(email)) {
            error.push("L'email est incorrect")
        }
        if (!phoneRef.current.phoneValidation(phone)) {
            error.push("Le numéro de téléphone est incorrect")
        }
        if (!subjectRef.current.textValidation(subject)) {
            error.push("L'objet est incorrect")
        }
        if (!messageRef.current.textValidation(message)) {
            error.push("Le message est incorrect")
        }
        if (!ip) {
            error.push(text('contact.inputIPError'))
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoadingMessage(false)
        } else {
            const toastId = toast.loading("Envois...")
            axios.post(process.env.REACT_APP_API_URL + 'contact', {
                firstname: firstname,
                lastname: lastname,
                email: email,
                phone: phone,
                subject: subject,
                message: message,
                ip: ip
            }).then((response) => {
                if (response.data === 'CONTACT_CREATED') {
                    setFirstname("")
                    setFirstnameError(null)
                    setLastname("")
                    setLastnameError(null)
                    setEmail("")
                    setEmailError(null)
                    setPhone("")
                    setPhoneError(null)
                    setSubject("")
                    setSubjectError(null)
                    setMessage("")
                    setMessageError(null)
                    toast.update(toastId, { render: "Message envoyé", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                }
                setIsLoadingMessage(false)
            }).catch((error) => {
                if (error.response) {
                    console.log("error :\n" + JSON.stringify(error.response.data.message) + "\n\n")
                    var errorMessage = error.response.data.message
                    if (errorMessage === 'ERROR_PARAMS') {
                        errorMessage = "Erreur lors des paramètres transmis"
                    } else if (errorMessage === 'ERROR_CONTACT_SPAM') {
                        errorMessage = "Erreur, vous avez déjà envoyé un message il y a moins de 30 minutes"
                    } else if (errorMessage === 'ERROR_CONTACT_CREATION' || errorMessage === 'ERROR_CONTACT_EMAILSEND') {
                        errorMessage = "Erreur lors de l'envois du message"
                    }
                    toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                }
                setIsLoadingMessage(false)
            })
        }

    }

    return (

        <>
            <Helmet>
                <meta name="title" content="Nous contacter - Vietnamensemble" />
                <meta name="description" content="Association Vietnamensemble, nous contacter" />
                <meta property="og:title" content="Nous contacter - Vietnamensemble" />
                <meta property="og:description" content="Association Vietnamensemble, nous contacter" />
                <meta property="og:url" content="https://www.vietnamensemble.org/contactez-nous" />
                <link rel="canonical" href="https://www.vietnamensemble.org/contactez-nous" />
            </Helmet>

            <BrowserView>
                <div className='contact'>
                    <Fade>
                        <div className='contactTitle'>{text('contact.title')}</div>
                        <div className='contactSubtitle'>Une question ou une suggestion ? Vous souhaitez nous rejoindre ?</div>
                    </Fade>
                    <div className='contactForm'>
                        <div className='contactFormLeft'>
                            <Fade delay={300} duration={500}>
                                <div className='contactFormLeftItem'>
                                    <FontAwesomeIcon icon={faLocationDot} className='contactFormTextIcon' />
                                    <b>Vietnam Ensemble (Về)</b>
                                    <br />
                                    5 rue Henri Dunant
                                    <br />
                                    95600 Eaubonne
                                </div>
                                <div className='contactFormLeftItem'>
                                    <FontAwesomeIcon icon={faEnvelope} className='contactFormTextIcon' />
                                    <b>contact@vietnamensemble.org</b>
                                    <br />
                                    N’hésitez pas à nous contacter
                                    <br />
                                    Nous nous ferons un plaisir de vous répondre...
                                </div>
                            </Fade>
                        </div>
                        <div className='contactFormRight'>
                            <Fade direction={'left'} duration={500}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'name'}
                                            theme={'dark'}
                                            ref={firstnameRef}
                                            icon={<FontAwesomeIcon icon={faUser} />}
                                            text={firstname} setText={setFirstname}
                                            textError={firstnameError} setTextError={setFirstnameError}
                                            placeholder={text('contact.inputFirstname')}
                                            maxLength={32}
                                            onPressEnter={() => lastnameRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                    <Col>
                                        <InputText
                                            type={'name'}
                                            theme={'dark'}
                                            ref={lastnameRef}
                                            text={lastname} setText={setLastname}
                                            textError={lastnameError} setTextError={setLastnameError}
                                            icon={<FontAwesomeIcon icon={faUser} />}
                                            placeholder={text('contact.inputLastname')}
                                            maxLength={32}
                                            onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={50} >
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'email'}
                                            theme={'dark'}
                                            ref={emailRef}
                                            text={email} setText={setEmail}
                                            textError={emailError} setTextError={setEmailError}
                                            icon={<FontAwesomeIcon icon={faEnvelope} />}
                                            placeholder={text('contact.inputEmail')}
                                            maxLength={128}
                                            onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                    <Col>
                                        <InputText
                                            type={'phone'}
                                            theme={'dark'}
                                            ref={phoneRef}
                                            text={phone} setText={setPhone}
                                            textError={phoneError} setTextError={setPhoneError}
                                            nullable={true}
                                            icon={<FontAwesomeIcon icon={faPhone} />}
                                            placeholder={text('contact.inputPhone')}
                                            maxLength={14}
                                            onPressEnter={() => messageRef.current.inputTextareaRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'text'}
                                            theme={'dark'}
                                            ref={subjectRef}
                                            text={subject} setText={setSubject}
                                            textError={subjectError} setTextError={setSubjectError}
                                            icon={<FontAwesomeIcon icon={faPen} />}
                                            placeholder={"Objet"}
                                            maxLength={128}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={150}>
                                <Row>
                                    <Col>
                                        <InputTextarea
                                            type={'textarea'}
                                            theme={'dark'}
                                            ref={messageRef}
                                            text={message} setText={setMessage}
                                            textError={messageError} setTextError={setMessageError}
                                            icon={<FontAwesomeIcon icon={faPen} />}
                                            placeholder={text('contact.inputMessage')}
                                            nbRow={6}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Row>
                                <Col>
                                    {!isLoadingMessage ?
                                        <Fade direction={'up'} delay={200} duration={500}>
                                            <Button theme={'dark'} rounded={true} icon={<FontAwesomeIcon icon={faPaperPlane} className='buttonIcon' />} text={text('contact.button')} onClick={() => sendMessage()} />
                                        </Fade>
                                        :
                                        <Fade duration={500}>
                                            <br />
                                            <RotatingLines
                                                strokeColor={"#5b7c18"}
                                                strokeWidth={"5"}
                                                animationDuration={"1"}
                                                width={"40"}
                                                visible={true}
                                            />
                                        </Fade>
                                    }
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </BrowserView>

            <MobileView>
                <div className='contact'>
                    <Fade>
                        <div className='contactTitle'>{text('contact.title')}</div>
                        <div className='contactSubtitleMobile'>
                            Une question ou une suggestion ?
                            <br />
                            Vous souhaitez nous rejoindre ?
                        </div>
                    </Fade>
                    <div className='contactFormMobile'>
                        <div className='contactFormLeftMobile'>
                            <Fade duration={500}>
                                <div className='contactFormLeftItem'>
                                    <FontAwesomeIcon icon={faLocationDot} className='contactFormTextIcon' />
                                    <b>Vietnam Ensemble (Về)</b>
                                    <br />
                                    5 rue Henri Dunant
                                    <br />
                                    95600 Eaubonne
                                </div>
                                <div className='contactFormLeftItem'>
                                    <FontAwesomeIcon icon={faEnvelope} className='contactFormTextIcon' />
                                    <b>contact@vietnamensemble.org</b>
                                    <br />
                                    N’hésitez pas à nous contacter
                                    <br />
                                    Nous nous ferons un plaisir de vous répondre...
                                </div>
                            </Fade>
                        </div>
                        {/* <div className='contactFormRightMobile'>
                            <Fade direction={'left'} duration={500}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'name'}
                                            theme={'dark'}
                                            ref={firstnameRef}
                                            icon={<FontAwesomeIcon icon={faUser} />}
                                            text={firstname} setText={setFirstname}
                                            textError={firstnameError} setTextError={setFirstnameError}
                                            placeholder={text('contact.inputFirstname')}
                                            maxLength={32}
                                            onPressEnter={() => lastnameRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={50}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'name'}
                                            theme={'dark'}
                                            ref={lastnameRef}
                                            text={lastname} setText={setLastname}
                                            textError={lastnameError} setTextError={setLastnameError}
                                            icon={<FontAwesomeIcon icon={faUser} />}
                                            placeholder={text('contact.inputLastname')}
                                            maxLength={32}
                                            onPressEnter={() => emailRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'left'} duration={500} delay={100}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'email'}
                                            theme={'dark'}
                                            ref={emailRef}
                                            text={email} setText={setEmail}
                                            textError={emailError} setTextError={setEmailError}
                                            icon={<FontAwesomeIcon icon={faEnvelope} />}
                                            placeholder={text('contact.inputEmail')}
                                            maxLength={128}
                                            onPressEnter={() => phoneRef.current.inputTextRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'right'} duration={500} delay={150}>
                                <Row>
                                    <Col>
                                        <InputText
                                            type={'phone'}
                                            theme={'dark'}
                                            ref={phoneRef}
                                            text={phone} setText={setPhone}
                                            textError={phoneError} setTextError={setPhoneError}
                                            nullable={true}
                                            icon={<FontAwesomeIcon icon={faPhone} />}
                                            placeholder={text('contact.inputPhone')}
                                            maxLength={14}
                                            onPressEnter={() => messageRef.current.inputTextareaRef.current.focus()}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Fade direction={'left'} duration={500} delay={200}>
                                <Row>
                                    <Col>
                                        <InputTextarea
                                            type={'textarea'}
                                            theme={'dark'}
                                            ref={messageRef}
                                            text={message} setText={setMessage}
                                            textError={messageError} setTextError={setMessageError}
                                            icon={<FontAwesomeIcon icon={faPen} />}
                                            placeholder={text('contact.inputMessage')}
                                            nbRow={6}
                                        />
                                    </Col>
                                </Row>
                            </Fade>
                            <Row>
                                <Col>
                                    {!isLoadingMessage ?
                                        <Fade direction={'up'} delay={200} duration={500}>
                                            <Button theme={'dark'} rounded={true} icon={<FontAwesomeIcon icon={faPaperPlane} className='buttonIcon' />} text={text('contact.button')} onClick={() => sendMessage()} />
                                        </Fade>
                                        :
                                        <Fade duration={500}>
                                            <br />
                                            <RotatingLines
                                                strokeColor={"#5b7c18"}
                                                strokeWidth={"5"}
                                                animationDuration={"1"}
                                                width={"40"}
                                                visible={true}
                                            />
                                        </Fade>
                                    }
                                </Col>
                            </Row>
                        </div> */}
                    </div>
                </div>
            </MobileView>
        </>

    )

}

export default Contact
